module.exports = __webpack_public_path__ + "static/media/swayams_mishra.d592ecff.jpg";